import { signOut } from 'next-auth/react';

const SIGN_IN_URL = '/auth/sign-in';

export const signOutToLogin = async (hasSession: boolean) => {
    if (hasSession) {
        await signOut({ callbackUrl: SIGN_IN_URL, redirect: false });
    }
    window.location.href = SIGN_IN_URL;
};
